import React, { useState, useEffect, useContext } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

import { isEmpty, get, forIn } from 'lodash';
import WidgetSectionTitle from '../../../widgets/CustomWidgetSectionTitle';
import useAPI from 'hooks/useApi';
import AppContext from 'context/Context';
import waterIcon from 'assets/img/icons/water.svg';
import locationIcon from 'assets/img/icons/land.svg';
import soilIcon from 'assets/img/icons/soil_param.svg';
import Enviroment from 'assets/img/icons/Enviroment.svg';

import MonitoringStats from './MonitoringStats';
import { getEnvironmentologyMonitoring } from 'api/endpoints/EnvironmentalServices';
import { getTerrestrialMonitoring } from 'api/endpoints/TerrestrialServices';
import { getSoilMonitoring } from 'api/endpoints/PedologicalServices';
import { getHydrologicalMonitoring } from 'api/endpoints/HydrologicalServices';
import { getOverallMonitoring } from 'api/endpoints/TerrestrialServices';
import StatisticsCard from '../saas/stats-cards/StatisticsCard';
import { useOutletContext, useParams } from 'react-router-dom';
import ErrorNotFound from 'components/errors/ErrorNotFound';
import MonitoringStatsSkeleton from './skeleton/MonitoringStatsSkeleton';
import StatiticsCardsSkeleton from './skeleton/StatiticsCardsSekeleton';
import CardSkeleton from 'components/common/skeleton/CardSkeleton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { getProjectDetails } from 'api/endpoints/ManagementServices';

import { jwtDecode } from 'jwt-decode';
import ObservationRender from './ObservationRender';
import MultiYearMap from './MultiYearMap';
import { getTenantFromToken } from 'utils/routeUtils';

const Monitoring = () => {
  const { setConfig } = useContext(AppContext);
  const {
    config: { isDark }
  } = useContext(AppContext);

  const tenant = getTenantFromToken();

  const { request_id } = useParams();
  const { setApisLoading } = useOutletContext();

  const { cluster } = useParams();
  const [showErrorPage, setshowErrorPage] = useState(false);

  const getProjectDetailsAPI = useAPI(getProjectDetails);
  const getEnvironmentologyMonitoringAPI = useAPI(
    getEnvironmentologyMonitoring
  );
  const getHydrologicalMonitoringAPI = useAPI(getHydrologicalMonitoring);
  const getOverAllMonitoringAPI = useAPI(getOverallMonitoring);
  const getTerrestrialMonitoringAPI = useAPI(getTerrestrialMonitoring);
  const getSoilMonitoringAPI = useAPI(getSoilMonitoring);

  const [ProjectDetails, setProjectDetails] = useState({});
  const [coordinates, setCoordinates] = useState([]);
  const [soilMonitoringData, setSoilMonitoringData] = useState([]);
  const [overAllMonitoringData, setOverAllMonitoringData] = useState({});
  const [environmentologyMonitoringData, setEnvironmentologyMonitoringData] =
    useState({});
  const [hydrologicalMonitoringData, setHydrologicalMonitoringData] = useState(
    {}
  );
  const [terrestrialMonitoringData, setTerrestrialMonitoringData] = useState(
    {}
  );

  const apiHooks = [
    getOverAllMonitoringAPI,
    getTerrestrialMonitoringAPI,
    getHydrologicalMonitoringAPI,
    getEnvironmentologyMonitoringAPI,
    getSoilMonitoringAPI
  ];

  const performSequentialAPICalls = async currentCluster => {
    setApisLoading(true);
    for (let i = 0; i < apiHooks.length; i++) {
      await apiHooks[i].request(currentCluster);
    }
    setApisLoading(false);
  };

  const resetApiStates = () => {
    for (let i = 0; i < apiHooks.length; i++) {
      apiHooks[i].setLoading(true);
    }
  };

  useEffect(() => {
    setConfig('cluster', cluster);
    setshowErrorPage(false);

    if (cluster) {
      resetApiStates(); // Reset loading and data for all APIs

      performSequentialAPICalls(cluster);
    }
  }, [cluster]);

  useEffect(() => {
    if (
      !isEmpty(getOverAllMonitoringAPI.error) ||
      !isEmpty(getTerrestrialMonitoringAPI.error) ||
      !isEmpty(getHydrologicalMonitoringAPI.error) ||
      !isEmpty(getEnvironmentologyMonitoringAPI.error) ||
      !isEmpty(getProjectDetailsAPI.error) ||
      !isEmpty(getSoilMonitoringAPI.error)
    ) {
      setshowErrorPage(true);
    }
  }, [
    getOverAllMonitoringAPI.error,
    getTerrestrialMonitoringAPI.error,
    getHydrologicalMonitoringAPI.error,
    getEnvironmentologyMonitoringAPI.error,
    getProjectDetailsAPI.error,
    getSoilMonitoringAPI.error
  ]);

  const fetchProjectDetails = () => {
    // setLoading(true);
    Promise.all([
      getProjectDetailsAPI.request({
        tenant: tenant,
        request_id: cluster
      })
    ]).then(() => {
      // setLoading(false);
    });
  };
  useEffect(() => {
    fetchProjectDetails();
  }, [tenant, cluster]);

  useEffect(() => {
    const data = get(getProjectDetailsAPI.data, 'results', {});
    setProjectDetails(data);
  }, [getProjectDetailsAPI.data]);

  // useEffect(() => {
  //   if (ProjectDetails && ProjectDetails?.coordinates) {
  //     const coordinatesArray = ProjectDetails?.coordinates
  //       .match(/-?\d+\.\d+/g)
  //       .map(Number);
  //     const formattedCoordinates = [];
  //     for (let i = 0; i < coordinatesArray.length; i += 2) {
  //       formattedCoordinates.push([
  //         coordinatesArray[i + 1],
  //         coordinatesArray[i]
  //       ]);
  //     }
  //     console.log(ProjectDetails, 'ProjectDetails');
  //     setCoordinates(formattedCoordinates);
  //   }
  // }, [ProjectDetails]);

  useEffect(() => {
    if (ProjectDetails && ProjectDetails.coordinates) {
      const isMultiPolygon =
        ProjectDetails.coordinates.includes('MULTIPOLYGON');

      if (isMultiPolygon) {
        const coordinatesRegex = /\(\((.*?)\)\)/g;
        const matches = ProjectDetails.coordinates.match(coordinatesRegex);

        if (matches) {
          const formattedCoordinates = matches.map(match => {
            const coordinatesArray = match.match(/-?\d+\.\d+/g).map(Number);

            const formatted = [];
            for (let i = 0; i < coordinatesArray.length; i += 2) {
              formatted.push([coordinatesArray[i + 1], coordinatesArray[i]]);
            }
            return formatted;
          });
          setCoordinates(formattedCoordinates);
        }
      } else {
        const coordinatesArray = ProjectDetails?.coordinates
          .match(/-?\d+\.\d+/g)
          .map(Number);
        const formattedCoordinates = [];
        for (let i = 0; i < coordinatesArray.length; i += 2) {
          formattedCoordinates.push([
            coordinatesArray[i + 1],
            coordinatesArray[i]
          ]);
        }
        setCoordinates(formattedCoordinates);
      }
    }
  }, [ProjectDetails]);

  useEffect(() => {
    if (!isEmpty(getOverAllMonitoringAPI.data)) {
      setOverAllMonitoringData(
        get(getOverAllMonitoringAPI.data, 'results', {})
      );
    }
    const reportUrl = get(
      getOverAllMonitoringAPI.data,
      'results.assessment_report',
      ''
    );
    setConfig('pdfReportUrl', reportUrl);
  }, [getOverAllMonitoringAPI.data]);

  useEffect(() => {
    if (!isEmpty(getSoilMonitoringAPI.data)) {
      setSoilMonitoringData(get(getSoilMonitoringAPI.data, 'results', {}));
    }
  }, [getSoilMonitoringAPI.data]);
  useEffect(() => {
    if (!isEmpty(getTerrestrialMonitoringAPI.data)) {
      setTerrestrialMonitoringData(
        get(getTerrestrialMonitoringAPI.data, 'results', {})
      );
    }
  }, [getTerrestrialMonitoringAPI.data]);

  useEffect(() => {
    if (!isEmpty(getEnvironmentologyMonitoringAPI.data)) {
      setEnvironmentologyMonitoringData(
        get(getEnvironmentologyMonitoringAPI.data, 'results', {})
      );
    }
  }, [getEnvironmentologyMonitoringAPI.data]);

  useEffect(() => {
    if (!isEmpty(getHydrologicalMonitoringAPI.data)) {
      setHydrologicalMonitoringData(
        get(getHydrologicalMonitoringAPI.data, 'results', {})
      );
    }
  }, [getHydrologicalMonitoringAPI.data]);

  // Assuming your array is called features

  const environmentologyObservation = get(
    environmentologyMonitoringData,
    'environmentology_observation'
  );

  const terrestrialObservation = get(
    terrestrialMonitoringData,
    'terrestrial_observation',
    {}
  );
  const hydrologicalObservation = get(
    hydrologicalMonitoringData,
    'hydrological_observation',
    {}
  );
  const Pedological_observation = get(
    soilMonitoringData,
    'pedological_observation'
  );

  const overallScore = get(overAllMonitoringData, 'overall_score', {});

  const overallData = [];
  forIn(overallScore, (value, key) => {
    overallData.push({
      title: key === 'green_cover' ? 'Green Cover' : key,
      suffix: '%',
      ...overallScore[key]
    });
  });

  // console.log(hydrologicalObservation, 'hydrologicalObservation');
  // console.log(environmentologyObservation, 'environmentologyObservation');
  // console.log(terrestrialObservation, 'terrestrialObservation');
  // console.log(Pedological_observation, 'Pedological_observation');
  // console.log(overAllMonitoringData?.asessment_details);
  // console.log(Pedological_observation);

  let Soc = [
    {
      label: 'Soil Organic Carbon',
      file: 'soc.tif',
      variant: '2024',
      info: '',
      desc: '',
      url: 'https://ansio-earth-engine.s3.amazonaws.com/source_raw/seedbomb_details/seedbomb_raster_details/tenant_id%3D0f8e8a4d58f94bf38f56cea9b1fa35fb/project_id%3D4dd625c9e8c047a99111a6f72025128b/soil_texture.tif?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT75QXDGND5XG7WQZ%2F20240216%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240216T123019Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=c63d9e5f4a1c87f23d19e1cb5f9a946ea759dc56411a95b99490e52cd7a6d4ee',
      data: [
        { lon: 78.48444444, lat: 21.80416667, soc: 0.476 },
        { lon: 78.57, lat: 21.36753, soc: 0.523 },
        { lon: 78.47546, lat: 21.37247, soc: 0.504 },
        { lon: 78.69055556, lat: 21.82833333, soc: 0.515 },
        { lon: 78.877476, lat: 21.636394, soc: 0.312 },
        { lon: 78.825186, lat: 21.659559, soc: 0.324 },
        { lon: 78.877439, lat: 21.636386, soc: 0.261 },
        { lon: 78.5075, lat: 21.74916667, soc: 0.498 },
        { lon: 78.56508, lat: 21.661874, soc: 0.431 },
        { lon: 78.4735, lat: 21.31522, soc: 0.256 },
        { lon: 78.57193, lat: 21.37078, soc: 0.443 },
        { lon: 78.4768, lat: 21.31355, soc: 0.218 },
        { lon: 78.877438, lat: 21.636389, soc: 0.328 },
        { lon: 78.71833333, lat: 21.74916667, soc: 0.502 },
        { lon: 78.447307, lat: 21.69421, soc: 0.351 },
        { lon: 78.449439, lat: 21.679308, soc: 0.502 },
        { lon: 78.551823, lat: 21.667057, soc: 0.21 },
        { lon: 78.79861111, lat: 21.62444444, soc: 0.513 },
        { lon: 78.93805556, lat: 21.72694444, soc: 0.328 },
        { lon: 78.797401, lat: 21.641993, soc: 0.198 },
        { lon: 78.47323, lat: 21.46881, soc: 0.265 },
        { lon: 78.83015, lat: 21.64176, soc: 0.417 },
        { lon: 78.71583333, lat: 21.92722222, soc: 0.253 },
        { lon: 78.56886, lat: 21.36857, soc: 0.504 },
        { lon: 78.455834, lat: 21.650385, soc: 0.409 },
        { lon: 78.877306, lat: 21.636375, soc: 0.356 },
        { lon: 78.4731, lat: 21.31831, soc: 0.452 },
        { lon: 78.56994, lat: 21.3674, soc: 0.464 },
        { lon: 78.57364, lat: 21.37244, soc: 0.42 },
        { lon: 78.461518, lat: 21.693372, soc: 0.502 },
        { lon: 78.51611111, lat: 21.69, soc: 0.365 },
        { lon: 78.564048, lat: 21.663859, soc: 0.182 },
        { lon: 78.572, lat: 21.3706, soc: 0.192 },
        { lon: 78.564544, lat: 21.662354, soc: 0.53 },
        { lon: 78.56999, lat: 21.36753, soc: 0.402 },
        { lon: 78.759439, lat: 21.772245, soc: 0.192 },
        { lon: 78.837392, lat: 21.639784, soc: 0.551 },
        { lon: 78.877506, lat: 21.636288, soc: 0.165 },
        { lon: 78.57201, lat: 21.37085, soc: 0.31 },
        { lon: 78.4709, lat: 21.46185, soc: 0.561 },
        { lon: 78.826701, lat: 21.641841, soc: 0.461 },
        { lon: 78.563112, lat: 21.664498, soc: 0.265 },
        { lon: 78.57356, lat: 21.37221, soc: 0.475 }
      ]
    }
  ];

  return (
    <>
      {showErrorPage ? (
        <ErrorNotFound />
      ) : (
        <>
          <Row className="g-3 mb-3 mt-1">
            <Col md="12" className="mt-0">
              {isEmpty(overAllMonitoringData?.asessment_details) ||
              getOverAllMonitoringAPI.loading ? (
                <MonitoringStatsSkeleton />
              ) : (
                <MonitoringStats
                  data={overAllMonitoringData?.asessment_details}
                />
              )}
            </Col>
          </Row>
          <Row className="g-3 mb-3">
            {getOverAllMonitoringAPI.loading ? (
              <StatiticsCardsSkeleton />
            ) : !isEmpty(overallData) ? (
              overallData?.map((stat, index) => (
                <Col md={4} key={index}>
                  <StatisticsCard
                    stat={stat}
                    style={{ minWidth: '12rem', height: '100%' }}
                    index={index}
                  />
                </Col>
              ))
            ) : (
              <></>
            )}
          </Row>
          {/* {(getTerrestrialMonitoringAPI.loading ||
            getHydrologicalMonitoringAPI.loading) && (
            <Row className="g-3 mb-3">
              <Col md={6}>
                <CardSkeleton footer={false} />
              </Col>
              <Col md={6}>
                <CardSkeleton footer={false} />
              </Col>
              <Col md={12}>
                <CardSkeleton footer={false} />
              </Col>
            </Row>
          )} */}
          {!isEmpty(terrestrialObservation) && (
            <WidgetSectionTitle
              icon={locationIcon}
              title="Vegetation Parameters"
              transform="shrink-4"
              className="mb-4 mt-4 align-items-center"
            />
          )}
          <Row className="g-3 mb-3">
            <ObservationRender
              key={'terrestrialObservation'}
              observation={terrestrialObservation}
              loading={getTerrestrialMonitoringAPI.loading}
              coordinates={coordinates}
            />
          </Row>
          {!isEmpty(hydrologicalObservation) && (
            <WidgetSectionTitle
              icon={waterIcon}
              title="Water Availability"
              transform="shrink-4"
              className="mb-4 mt-4 align-items-center"
              light={true}
            />
          )}

          <Row className="g-3 mb-3">
            <ObservationRender
              key={'hydrologicalObservation'}
              observation={hydrologicalObservation}
              loading={getHydrologicalMonitoringAPI.loading}
              coordinates={coordinates}
            />
          </Row>
          {!isEmpty(environmentologyObservation) && (
            <WidgetSectionTitle
              icon={Enviroment}
              title="Air Quality"
              transform="shrink-4"
              className="mb-4 mt-4 align-items-center"
            />
          )}
          <Row className="g-3 mb-3">
            <ObservationRender
              key={'environmentologyObservation'}
              observation={environmentologyObservation}
              loading={getEnvironmentologyMonitoringAPI.loading}
              coordinates={coordinates}
            />
          </Row>
          {!isEmpty(Pedological_observation) && (
            <WidgetSectionTitle
              icon={soilIcon}
              title="Soil Parameters"
              transform="shrink-4"
              className="mb-4 mt-4 align-items-center"
            />
          )}
          <Row className="g-3 mb-3">
            <ObservationRender
              key={'Pedological_observation'}
              observation={Pedological_observation}
              loading={getSoilMonitoringAPI.loading}
              coordinates={coordinates}
            />
          </Row>

          {
            <Row>
              {cluster == '4dd625c9e8c047a99111a6f72025128b' && (
                <Col lg={12}>
                  {isEmpty(Pedological_observation) ||
                  getSoilMonitoringAPI.loading ? (
                    <CardSkeleton />
                  ) : (
                    <MultiYearMap
                      data={Soc}
                      coordinates={coordinates}
                      type="dummy"
                    />
                  )}
                </Col>
              )}
            </Row>
          }
        </>
      )}
    </>
  );
};

export default Monitoring;
